<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="reward-view" v-if="giftList[0].giftId != 'S001'" :class="{'lg' : giftList.length > 4}">
                        <div class="reward-item" v-for="(item,index) in giftList" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.gameGiftId" v-if="item.gameGiftId != 'S001' && item.giftId != 'OJ361'">
                                    <game-item :locked="true" :id="item.gameGiftId" :num="item.sendNum || item.num || 1"></game-item>
                                </div>
                                <div class="pic" v-else>
                                    <game-item :locked="true" :id="item.giftId =='OJ361' ? 'S002' : 'S001'" :num="1"></game-item>
                                </div>                                
                            </div>                              
                        </div>
                    </div>

                    <div class="msg-view">
                        门神赐福已发放至军师邮件，请注意查收!
                    </div>

            
                    <div class="u-btn ok" @click="destroyElement()"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .dialog-view{
        z-index: 100;
    }

    .msg-modal{
        // width: 642px;
        // height: 435px;
        // background-image: url(~@/assets/images/modal/bg-modal-sm.png);     
    }

    .title{
        // width: 264px;
        // height: 28px;
        // margin: 0 auto 12px;
        // background-image: url(~@/assets/images/modal/title-result.png);               
    }    

    .msg-view{
        padding: 0 70px;
        text-align: center;
        margin: 0 auto 10px;  
        font-size: 20px;
    }

    .msg-view.singel{
        margin-top: 100px;
    }

    .reward-view{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 50px;
        margin: 20px 0 20px;
    }

    .reward-view.lg{
        padding: 0 20px;
    }

    .reward-item{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 104px;
        height: 104px;
        margin: 0 20px 10px;
        // background-color: #e3cda4;
        background-image: url(~@/assets/images/modal/bg-item.png); 

        transform: scale(0);
        opacity: 0;
        transform-origin: center;
        animation: box_show 0.4s;
        animation-fill-mode: forwards;

        @for $i from 1 through 10{
            &:nth-child(#{$i}) {                
                animation-delay: $i*0.5s;               
            }
        }
        
        .lg &{
            margin: 0 12px 10px;
        }
    }

    .r-wrapper{
        width: 69px;
        height: 69px;
    }

    .r-wrapper>.pic{
        width: 100%;
        height: 100%;
    }


    .u-btn.ok{
        width: 205px;
        height: 55px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);    
    }
  
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rid : 1,
            giftList : [
                { gameGiftId : 'PK04'  , sendNum : 2},
                { gameGiftId : 'KQ48'  , sendNum : 3},
                { gameGiftId : 'OJ04'  , sendNum : 1},
            ],
            isSSR : false,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>